var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container"},[_c('Survey',{attrs:{"questions":_vm.questions,"previous-component-name":_vm.previousComponentName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }